const UNCATEGORIZED_CATEGORY_CODE = "NONE";

export default UNCATEGORIZED_CATEGORY_CODE;
